import { NavLink, useRouteMatch, withRouter } from "react-router-dom";
import { isTokenValid } from "../../utils/otherUtils";

const Header = (props) => {
  // const routeArray = [
  //   "/email-verify",
  //   "/set-password",
  //   "/developer/setup-enterprise",
  //   "/developer/setup-user",
  //   "/signup-success",
  // ]
  const { url, path } = useRouteMatch();
  console.log("url : ", url);
  const activeArray = [
    //
  ];
  const mainArray = [
    "/faq",
    "/Aggregator/documents"
  ];

  if(process.env.REACT_APP_ANALYTICS_TYPE === "vi"){
  return (
    <nav className="navbar navbar-default navbar-fixed-top navbar-bg">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
            aria-expanded="false"
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar" />
            <span className="icon-bar" />
            <span className="icon-bar" />
          </button>
          <div className="navbar-brand">
            <a href="/">
              <img
                src="images/vi_logo.svg"
                className="vi-navbar-logo-size"
                alt="VI"
              />
            </a>
          </div>
        </div>
        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          {/* {!isTokenValid() && (
            <ul className="nav navbar-nav navbar-right">
              <li className={(props.location.pathname===(mainArray[0]) && "nav-selected-main")}>
                <NavLink className={(props.location.pathname===(mainArray[0]) ? "fw-5 nav-selected-main" :"fw-5")} to={"/faq"}>
                  FAQs
                </NavLink>
              </li>
              <li className={(props.location.pathname===(mainArray[1]) && "nav-selected-main")}>
                <NavLink className={(props.location.pathname===(mainArray[1]) ? "fw-5 nav-selected-main" :"fw-5")} to={"/Aggregator/documents"}>
                  DOWNLOADS
                </NavLink>
              </li>
            </ul>
          )} */}
        </div>
      </div>
    </nav>
  )
  }

  else{
  return (
    <nav className="navbar navbar-default navbar-fixed-top navbar-bg">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
            aria-expanded="false"
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar" />
            <span className="icon-bar" />
            <span className="icon-bar" />
          </button>
          <div className="navbar-brand">
            <a href="/">
              <img
                src="images/dotgo_logo_white.svg"
                width={95}
                alt="Dotgo"
              />
            </a>
          </div>
        </div>
        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          {/* {!isTokenValid() && (
            <ul className="nav navbar-nav  navbar-right">
              <li className={(props.location.pathname===(mainArray[0]) && "active")}>
                <NavLink className={(props.location.pathname===(mainArray[0]) ? "fw-5 nav-selected-main" :"fw-5")} to={"/faq"}>
                  FAQs
                </NavLink>
              </li>
              <li className={(props.location.pathname===(mainArray[1]) && "active")}>
                <NavLink className={(props.location.pathname===(mainArray[1]) ? "fw-5 nav-selected-main" :"fw-5")} to={"/Aggregator/documents"}>
                  DOWNLOADS
                </NavLink>
              </li>
            </ul>
          )} */}
        </div>
      </div>
    </nav>
  )
  }
};

export default withRouter(Header);
